// extracted by mini-css-extract-plugin
export default {"container":"Greetings_container__BZdnf","description":"Greetings_description__D1rDg","button":"Greetings_button__lv-lu"};